export default __webpack_public_path__ + "static/media/IconDesc_CeilingLight.256.793c350e.png";